<template>
  <v-dialog
    v-model="show"
    persistent
    :max-width="$vuetify.display.mobile ? `80vw` : `50vw`"
  >
    <v-card class="custom-card">
      <v-card-title class="text-h6 text-center">
        {{ text }}
      </v-card-title>
      <v-btn color="rsz500" size="x-large" variant="text" @click="closeDialog">
        {{ okayText }}
      </v-btn>
      <v-btn v-if="shouldNo" color="rsz500" size="x-large" variant="text" @click="noDialog">
        {{ noText }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: `SaveDialog`,
  props: {
    text: {
      type: String,
      default: 'Változtatások sikeresen elmentve!',
    },
    okayText: {
      type: String,
      default: 'Rendben',
    },
    noText: {
      type: String,
      default: 'Mégsem',
    },
    shouldNo: {
      type: Boolean,
      default: false,
    },
    showdialog: {
      type: Boolean,
      default: false, // Set the default value to false
    },
  },
  emits: ['dialogChange'],
  data() {
    return {
      show: this.showdialog,
    }
  },
  watch: {
    showdialog(newValue) {
      this.show = newValue
    },
  },
  methods: {
    closeDialog() {
      this.show = false
      this.$emit(`dialogChange`, true)
    },
    noDialog() {
      this.show = false
      this.$emit(`dialogChange`, false)
    },
  },
})
</script>
